module.exports = __webpack_public_path__ + "img/2025-08-01.c4503ed.png";